import { observer } from 'mobx-react'
import { Trans, useTranslation } from 'next-i18next'
import { FC } from 'react'
import styles from './index.module.scss'
import { useStores } from '../../../utils'
import { CloseButton } from '../../atoms/CloseButton'

type Props = {
  type: 'jobSeeker' | 'investor' | 'startup'
}

export const ProfileCompletionPromotionPopupContent: FC<Props> = observer(({ type }) => {
  const { t } = useTranslation(['p'])
  const { ui, viewer } = useStores()

  const toggleModal = () => {
    ui.toggleProfileInputModal()
  }

  let [title, text, href] = ['', '', '']
  if (type === 'jobSeeker') {
    title = `プロフィールを充実させ<br />企業にアピールしよう`
    text = '採用担当者が求める情報を追加することで、チャンスを広げることができます。'
    href = `/account/profile`
  }
  if (type === 'investor') {
    title = `プロフィールを充実させ<br />企業にアピールしよう`
    text = 'スタートアップが求める情報を追加することで、投資依頼等のチャンスを広げることができます。'
    href = `/account/profile/investor`
  }
  if (type === 'startup') {
    // 条件を満たす最初の company の slug を取得する
    const startupSlug = viewer.viewer.companyMembers?.find(
      (companyMember) =>
        !companyMember.company.isVc &&
        viewer.viewer.getMyCompanyBySlug(companyMember.company.slug).basicProfileCompletionRate < 50 &&
        viewer.viewer.getMyCompanyBySlug(companyMember.company.slug).startupProfileCompletionRate < 50
    )?.company.slug

    title = `プロフィールを充実させ<br />投資家にアピールしよう`
    text = '投資家が求める情報を追加することで、資金調達等のチャンスを広げることができます。'
    href = `/companies/${startupSlug}/account/profile/startup`
  }

  return (
    <>
      <div className={styles.heading}>
        <div className={styles.title}>
          <Trans i18nKey={type === 'startup' ? 'p:投資家へアピールしよう' : 'p:企業へアピールしよう'}>{title}</Trans>
        </div>
        <div className={styles.closeButton}>
          <CloseButton onClick={toggleModal} />
        </div>
      </div>
      <div className={styles.body}>
        <div className={styles.text}>{t(text)}</div>
      </div>
      <a className={styles.link} href={href} target='_blank' rel='noreferrer'>
        <span className={styles.linkText}>{t('プロフィール編集画面へ')}</span>
        <span className={styles.linkIcon} />
      </a>
    </>
  )
})
